import React from 'react';
import PropTypes from 'prop-types';
import {withRouter} from 'react-router-dom';
import bindAll from 'lodash.bindall';
import LibraryComponent from '../../../components/library/library-no-modal';

class CourseRecordList extends React.PureComponent {
    constructor(props) {
        super(props);
        bindAll(this, [
            'handleItemSelect'
        ]);
    }

    handleItemSelect(item) {
        this.props.history.push({pathname: '/course', search: item.extensionId});
    }
    render() {
        let items = this.props.items.map(item=>({
            extensionId: `id=${item.course_id}&clazz_id=${item.clazz_id}`,
            name: item.course.name,
            rawURL: window.config.staticURL + '/cover/course/' + item.course.id + '.png',
            //iconURL: "",
            //insetIconURL: ""
            featured: true,
            description: item.clazz.name,

        }));
        return (
            <React.Fragment>
                {/*<img style={{position: "absolute", zIndex:1, left:"18px", top:"21px"}} src={require('./new.png')} />*/}
                <LibraryComponent
                    data={items}
                    filterable={false}
                    id="CourseRecordLibrary"
                    title="课程列表"
                    visible={true}
                    onItemSelected={this.handleItemSelect}
                    onRequestClose={this.props.onRequestClose}
                />
            </React.Fragment>
        );
    }
}

CourseRecordList.propTypes = {
    items: PropTypes.arrayOf(PropTypes.object),
    onRequestClose: PropTypes.func
}

export default withRouter(CourseRecordList);
